import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.statistics');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ip-market-statistics',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.statistics/view.scss */
:host {
  display: block;
  height: 100%;
}

.statistics-page {
  max-width: 1600px;
  margin: 0 auto;
  padding: 30px;
  color: #172b3b;
  font-size: 13px;
}

.statistics-header, .period-panel, .period-fields, .quick-periods, .report-meta, .panel-heading, .detail-heading, .right-label, .table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.statistics-header {
  margin-bottom: 26px;
}

.eyebrow {
  color: #0e7490;
  letter-spacing: 0.12em;
  font-size: 11px;
  font-weight: 700;
  margin: 0 0 8px;
}

h1 {
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.04em;
  margin: 0 0 10px;
}

h2 {
  font-size: 15px;
  font-weight: 700;
  margin: 0;
}

.description, .panel-heading p, .detail-heading p {
  color: #64748b;
  margin: 7px 0 0;
  line-height: 1.7;
}

button {
  cursor: pointer;
  transition: background 0.15s;
  border-radius: 8px;
  font-weight: 600;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

button:focus-visible, input:focus-visible, summary:focus-visible, .table-wrap:focus-visible {
  outline: 3px solid #67e8f9;
  outline-offset: 3px;
}

.export-button, .query-button {
  background: #0e7490;
  color: white;
  padding: 11px 17px;
  border: 1px solid #0e7490;
  white-space: nowrap;
}

.export-button:hover, .query-button:hover {
  background: #155e75;
}

.period-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 16px 18px;
  border-radius: 12px;
  flex-wrap: wrap;
}

.period-fields {
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
}

.period-fields label {
  font-weight: 700;
  margin-right: 6px;
}

input {
  width: 149px;
  min-width: 0;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  padding: 8px;
  background: white;
  font: inherit;
  color: #334155;
}

.quick-periods {
  gap: 5px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.quick-periods button {
  padding: 7px 9px;
  background: white;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 12px;
}

.quick-periods button:hover {
  background: #ecfeff;
}

.report-meta {
  font-size: 11px;
  color: #64748b;
  margin: 23px 0 12px;
  flex-wrap: wrap;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.metric-card {
  padding: 21px;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  background: white;
}

.metric-label {
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.metric-card > strong {
  display: block;
  font-size: clamp(21px, 2.2vw, 30px);
  letter-spacing: -0.03em;
  margin: 15px 0 9px;
  overflow-wrap: anywhere;
}

.metric-card > strong.unavailable {
  font-size: 21px;
  color: #64748b;
}

.metric-card strong small {
  font-size: 13px;
  margin-left: 5px;
  color: #64748b;
  font-weight: 500;
}

.metric-card p {
  font-size: 11px;
  color: #64748b;
  line-height: 1.7;
}

.metric-tag {
  display: inline-block;
  font-size: 10px;
  color: #64748b;
  background: #f1f5f9;
  padding: 4px 7px;
  border-radius: 4px;
  margin-top: 9px;
}

.metric-tag.available {
  color: #0e7490;
  background: #ecfeff;
}

.featured {
  border-color: #a5d9e3;
  background: #f5fcfd;
}

.featured > strong {
  color: #0e7490;
}

.collection-note {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border-radius: 9px;
  background: #f8fafc;
  padding: 15px 18px;
  margin: 16px 0 24px;
  color: #475569;
  font-size: 12px;
  line-height: 1.8;
}

.collection-note p {
  margin: 2px 0 0;
}

.note-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #94a3b8;
  text-align: center;
  flex-shrink: 0;
  line-height: 17px;
  margin-top: 3px;
}

.chart-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: 18px;
  margin-bottom: 22px;
}

.chart-panel, .detail-panel {
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  background: white;
  min-width: 0;
}

.chart-panel {
  padding: 23px;
}

.chart-legend {
  color: #0e7490;
  font-size: 11px;
  white-space: nowrap;
}

.chart-legend::before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  background: #0891b2;
  border-radius: 2px;
  margin-right: 6px;
}

.month-chart {
  display: flex;
  gap: 12px;
  height: 225px;
  margin-top: 26px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.month-column {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  min-width: 34px;
}

.bar-value {
  color: #475569;
  font-size: 11px;
  margin-bottom: 6px;
}

.bar-track {
  height: 155px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  background: repeating-linear-gradient(to top, #f1f5f9 0, #f1f5f9 1px, transparent 1px, transparent 38px);
  border-bottom: 1px solid #cbd5e1;
  justify-content: center;
}

.month-bar {
  width: 65%;
  max-width: 38px;
  background: #0891b2;
  border-radius: 4px 4px 0 0;
}

.month-label {
  font-size: 10px;
  color: #64748b;
  margin-top: 9px;
  white-space: nowrap;
}

.rights-chart {
  display: grid;
  gap: 16px;
  margin-top: 25px;
}

.right-label {
  font-size: 12px;
  margin-bottom: 7px;
}

.right-label small {
  color: #64748b;
  margin-left: 10px;
  font-size: 10px;
}

.right-track {
  height: 7px;
  border-radius: 10px;
  background: #f1f5f9;
  overflow: hidden;
}

.right-bar {
  height: 100%;
  background: #0891b2;
  border-radius: 10px;
}

.detail-heading {
  padding: 23px;
  flex-wrap: wrap;
}

.detail-tabs {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  background: #f1f5f9;
  gap: 3px;
}

.detail-tabs button {
  border: 0;
  padding: 7px 14px;
  color: #64748b;
  background: transparent;
  font-size: 12px;
}

.detail-tabs button.active {
  background: white;
  color: #0e7490;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.0705882353);
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
}

th, td {
  padding: 14px 22px;
  text-align: right;
  border-bottom: 1px solid #f1f5f9;
}

th:first-child {
  text-align: left;
}

thead {
  background: #f8fafc;
  color: #64748b;
}

thead th {
  font-weight: 500;
  font-size: 11px;
}

tbody th {
  font-weight: 600;
}

tbody tr:hover {
  background: #f8fcfd;
}

.muted {
  color: #94a3b8;
}

.table-footer {
  padding: 15px 22px;
  background: #f8fafc;
  font-size: 11px;
  color: #475569;
  flex-wrap: wrap;
  border-radius: 0 0 13px 13px;
}

.basis-panel {
  margin-top: 20px;
  padding: 19px 23px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.9;
}

.basis-panel summary {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.basis-panel ul {
  padding-left: 17px;
  margin-top: 12px;
  list-style: disc;
}

.notice {
  padding: 12px 16px;
  background: #fffbeb;
  color: #92400e;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.8;
  margin: 12px 0;
}

.error-state, .loading-state, .empty-state {
  padding: 30px;
  text-align: center;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin: 20px 0;
  background: #f8fafc;
  line-height: 1.9;
}

.error-state {
  color: #991b1b;
  background: #fff7f7;
}

.error-state button {
  border: 1px solid #fecaca;
  padding: 6px 14px;
  background: white;
  margin-top: 10px;
}

.loading-state, .empty-state p {
  color: #64748b;
}

.loading-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #0891b2;
}

@media (max-width: 1150px) {
  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .chart-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 640px) {
  .statistics-page {
    padding: 19px 14px;
  }
  .statistics-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 15px;
  }
  h1 {
    font-size: 22px;
  }
  .metric-card {
    padding: 15px;
  }
  .metric-card > strong, .metric-card > strong.unavailable {
    font-size: 19px;
  }
  .period-fields label {
    flex-basis: 100%;
  }
  input {
    width: 126px;
  }
  .period-panel {
    padding: 13px;
  }
  .chart-panel {
    padding: 17px;
  }
  .detail-heading {
    padding: 17px;
  }
  .report-meta {
    gap: 5px;
  }
  th, td {
    padding: 12px 16px;
  }
}`],
})
export class PageIpMarketStatisticsComponent implements OnInit {
    public start = '';
    public end = '';
    public loading = false;
    public error = '';
    public report: any = null;
    public tab = 'monthly';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.setPeriod(12);
        await this.load();
    }

    private currentMonth() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit'
        }).formatToParts(new Date());
        return parts.find(p => p.type === 'year').value + '-' + parts.find(p => p.type === 'month').value;
    }

    public setPeriod(months: number) {
        this.end = this.currentMonth();
        const [year, month] = this.end.split('-').map(Number);
        const first = new Date(Date.UTC(year, month - months, 1));
        this.start = first.getUTCFullYear() + '-' + String(first.getUTCMonth() + 1).padStart(2, '0');
        this.service.render();
    }

    public setYear() {
        this.end = this.currentMonth();
        this.start = this.end.slice(0, 4) + '-01';
        this.service.render();
    }

    public async selectTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public pending() {
        return this.report && (this.report.start !== this.start || this.report.end !== this.end);
    }

    public async load() {
        if (this.loading) return;
        this.error = '';
        if (!/^\d{4}-\d{2}$/.test(this.start) || !/^\d{4}-\d{2}$/.test(this.end) || this.start > this.end) {
            this.error = '시작 월과 종료 월을 올바르게 선택해주세요.';
            await this.service.render();
            return;
        }
        const [sy, sm] = this.start.split('-').map(Number);
        const [ey, em] = this.end.split('-').map(Number);
        if ((ey - sy) * 12 + em - sm > 35) {
            this.error = '조회 기간은 최대 36개월입니다.';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.report = null;
        await this.service.render();
        try {
            const response = await wiz.call('report', { start: this.start, end: this.end });
            const payload = response?.responseJSON || response;
            if (Number(payload?.code) !== 200 || !payload?.data) {
                throw new Error(payload?.message || '통계 데이터를 불러오지 못했습니다.');
            }
            this.report = payload.data;
        } catch (error) {
            this.error = error?.message || '통계 데이터를 불러오지 못했습니다. 다시 조회해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public number(value: any) {
        return value === null || value === undefined ? '—' : Number(value).toLocaleString('ko-KR');
    }

    public percent(value: number) {
        return this.report?.total ? (value / this.report.total * 100).toFixed(1) : '0.0';
    }

    public bar(value: number, rows: any[]) {
        const max = Math.max(1, ...rows.map(row => row.count));
        return value / max * 100;
    }

    public exportCsv() {
        const r = this.report;
        if (!r || this.loading || this.pending()) return;
        const rows: any[][] = [
            ['IP 거래 통계 보고서'], ['조회 기간', r.start, r.end],
            ['시간대', r.timezone], ['조회 시각', r.generated_at],
            ['데이터 출처', 'Core API / IP_MARKET_PORTAL 판매신청'],
            ['이용 통계 상태', r.usage_note], [],
            ['요약', '값', '단위'],
            ['판매신청', r.total, '건'], ['평균 제시비용', r.average_price ?? '산정 불가', '원'],
            ['평균 산정 건수', r.priced_count, '건'], ['가격 제외 건수', r.excluded_price_count, '건'],
            ['접수일 누락·오류 제외 건수(전체 원본)', r.invalid_dates, '건'], [],
            ['월별 통계', '판매신청(건)', '접속자(명)', 'AI 검색(회)', '평균 제시비용(원)', '가격 산정(건)', '가격 제외(건)'],
            ...r.monthly.map(row => [row.month, row.count, '집계 미연동', '집계 미연동', row.average_price ?? '산정 불가', row.priced_count, row.excluded_price_count]),
            [], ['권리별 통계', '판매신청(건)', '비중(%)', '평균 제시비용(원)', '가격 산정(건)', '가격 제외(건)'],
            ...r.rights.map(row => [row.label, row.count, this.percent(row.count), row.average_price ?? '산정 불가', row.priced_count, row.excluded_price_count]),
            [], ['현재 처리상태', '판매신청(건)'], ...r.statuses.map(row => [row.label, row.count]),
            [], ['집계 기준'], ...r.basis.map(note => [note])
        ];
        const cell = (value: any) => {
            let text = String(value ?? '');
            if (/^[=+\-@\t\r]/.test(text)) text = "'" + text;
            return '"' + text.replace(/"/g, '""') + '"';
        };
        const csv = '\uFEFF' + rows.map(row => row.map(cell).join(',')).join('\r\n');
        const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'IP거래_통계_' + r.start + '_' + r.end + '.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
}

export default PageIpMarketStatisticsComponent;